<template>
    <section class="tables new-updated-design">
        <vue-snotify></vue-snotify>
        <div class="row">
            <div class="col-lg-12 grid-margin stretch-card">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">Email Templates</h4>
                    </div>
                    <div class="card-body">
                        <!-- <vue-good-table mode="remote" @on-page-change="onPageChange" @on-per-page-change="onPerPageChange"
                            :totalRows="totalRecords" :isLoading.sync="isLoading"
                            :pagination-options="{ enabled: true, dropdownAllowAll: false, perPageDropdown: [10, 20, 50, 100, 200], }"
                            :rows="rows" :sort-options="{
                                enabled: false,
                            }" :columns="columns">
                            <template slot="table-row" slot-scope="props">
                                <span v-if="props.column.field === 'action'" class="text-nowrap">
                                    <toggle-button v-model="spots.find(p => p.spot_id === props.row.user.id).spot_status"
                                        @change="changeStatus(props.row.user.id, $event)" :sync="true" color="#070708"
                                        class="mr-1" />
                                    <b-button size="sm" @click="editMember(props.row.user)"
                                        class="mr-1 btn-info text-white">
                                        Edit
                                    </b-button>
                                </span>
                            </template>
                        </vue-good-table> -->
                    <CircleLoader v-if="isLoading" />
                        <vue-good-table mode="remote" @on-page-change="onPageChange" @on-per-page-change="onPerPageChange"
                            v-else
                            :totalRows="tableConfig.totalRecords" 
                            :pagination-options="tableConfig.options" :rows="draftedEmailList" :sort-options="{
                                enabled: false,
                            }" :columns="tableConfig.columns">
                            <template slot="table-row" slot-scope="props">
                                <span v-if="props.column.field == 'action'">
                                    <button class="btn btn-sm btn-primary mr-3" @click="updateDraftEmail(props.row.id)">Edit</button>
                                    <button class="btn btn-sm btn-danger" @click="deleteDraftEmail(props.row.id)">delete</button>
                                </span>
                                <span v-else>
                                    {{ props.formattedRow[props.column.field] }}
                                </span>
                            </template>
                        </vue-good-table>
                    </div>
                </div>
            </div>
        </div>
        <div></div>
    </section>
</template>

<script>
import Vue from "vue";
import SortedTablePlugin from "vue-sorted-table";
import API from '@/api'
import Snotify, { SnotifyPosition } from 'vue-snotify'
import router from '../router';
import CircleLoader from '@/pages/loaders/CircleLoader.vue'; 
const options = {
    toast: {
        position: SnotifyPosition.rightTop,
    }
}
Vue.use(Snotify, options)
Vue.use(SortedTablePlugin, {
    ascIcon: '<i class="ti-arrow-down"></i>',
    descIcon: '<i class="ti-arrow-up"></i>'
});
export default {
    name: 'draftedEmail',
    data() {
        return {
            serverParams: {},
            draftedEmailList: {},
        isLoading: false,
            tableConfig: {
                columns: [
                    {
                        label: 'No#',
                        field: 'no',
                        filterable: false,
                    },
                    {
                        label: 'Title',
                        field: 'title',
                        sortable: false,
                    },
                    {
                        label: 'Group Name',
                        field: "group",
                        sortable: false,
                    },
                    {
                        label: 'Action',
                        field: "action",
                        sortable: false,
                    }
                ],
                options: {
                    enabled: true,
                    dropdownAllowAll: false,
                    perPageDropdown: [10, 20, 50, 100, 200],
                },
                totalRecords: 0,
                isLoading: false
            },
        };
    },
    methods: {
        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
        },
        onPageChange(params) {
            this.updateParams({ page: params.currentPage });
            this.getDraftedMailTemplates();
        },
        onPerPageChange(params) {
            this.updateParams({ perPage: params.currentPerPage });
            this.getDraftedMailTemplates();
        },
        deleteDraftEmail(id){
            this.$swal({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!'
                }).then((result) => {
                    if (result.value) {
                        API.deleteDraftEmail({id},this.deleteDraftEmailCB,this.errorCB)
                        this.getDraftedMailTemplates(this.serverParams, this.getDraftedMailTemplatesCB,this.errorCB)
                        this.$swal(
                            'Deleted!',
                            'Record has been deleted.',
                            'success'
                        )
                    }
                })
        },
        deleteDraftEmailCB(res){
            this.$snotify.success(res.message, {
                timeout: 2000,
                showProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
            });
        },
        getDraftedMailTemplates() {
            API.getDraftedMailTemplates(this.serverParams, this.getDraftedMailTemplatesCB, this.errorCB)
        },
        updateDraftEmail(id){
            router.push({name:"updateDraftEmail", params:{id}});
        },
        getDraftedMailTemplatesCB(response) {
            this.tableConfig.totalRecords = response.totalRecords;
            console.log(response);
            let i = 1;
            let group = '';
            let resData = response.data.data.map(data => {
                if (data.GroupID == 1)
                    group = 'Futures1';
                else if (data.GroupID == 2)
                    group = 'Futures2';

                else if (data.GroupID == 3)
                    group = 'Currents';
                else if (data.GroupID == 4)
                    group = 'Pasts';
                else
                    group = 'Custom';

                return {
                    no: i++,
                    title: `NewEmailmarketing - ${data.GroupID} - ${data.ContentID} - DCTrainings - ${data.StartDate}`,
                    group,
                    id:data.ContentID,
                }
            })
            console.log(resData);
            // console.log( this.draftedEmailList);
            this.draftedEmailList = resData
            this.isLoading = false;
        },
        errorCB(err) {
            console.log(err)
            this.isLoading = false;
        },
    },
    computed: {}
    ,
    mounted() {
        this.isLoading = true;
        this.getDraftedMailTemplates();
    }
}
</script>
